export default {
    EMessage: {
      'NO_RESULTS': { 'code': 0, 'message': 'No se encontraron resultados' },
      'COMPANY_NO_RESULTS': { 'code': 0, 'message': 'No se encontró el parqueadero o la compañia' },
      'OK': { 'code': 1, 'message': 'La petición se ejecutó correctamente' },
      'SYNCRONIZED_SUCCESSFUL': { 'code': 1, 'message': 'Se sincronizo correctamente' },
      'FILE_UPLOADED_SUCCESS': { 'code': 2, 'message': 'Se ha subido el archivo correctamente' },
      'ERROR_GENERAL': { 'code': -1, 'message': 'Error al procesar la petición' },
      'ERROR_COMMIT': { 'code': -1500, 'message': 'Error al confirmar los datos' },
      'ERROR_TOKEN_REQUIRED': { 'code': -1501, 'message': 'Error token is required' },
      'ERROR_VALUES': { 'code': -507, 'message': 'You must specify the values' },
      'ERROR_VALUES_NOT_FOUND': { 'code': -511, 'message': 'Value not found' },
      'ERROR_ACCESS_REQUIRED': { 'code': -1502, 'message': 'Debe ingresar la información básica de la persona' },
      'ERROR_EMAIL_REQUIRED': { 'code': -1503, 'message': 'El correo es obligtorio' },
      'ERROR_SECRET_REQUIRED': { 'code': -1504, 'message': 'La clave es obligatoria' },
      'ERROR_ENTITY_IDENTIFICATION_TYPE_REQUIRED': { 'code': -1505, 'message': 'El tipo de identificación es requerido' },
      'ERROR_ENTITY_NAME': { 'code': -1506, 'message': 'El nombre es requerido' },
      'ERROR_LOGIN': { 'code': -1507, 'message': 'Error en el usuario y/o clave' },
      'ERROR_ACCOUNT_EXIST': { 'code': -1508, 'message': 'El correo electrónico ya existe' },
      'ERROR_COMPANY_NAME': { 'code': -1509, 'message': 'El nombre de la empresa o parqueadero es requerido' },
      'ERROR_COMPANY_ADDRESS': { 'code': -1510, 'message': 'La dirección del parqueadero o empresa es requerido' },
      'ERROR_COMPANY_CLASSIFICATION': {
        'code': -1511,
        'message': 'La clasificación de la empresa o parqueadero es requerido'
      },
      'ERROR_COMPANY_FATHER': { 'code': -1512, 'message': 'Debe seleccionar la empresa a la que pertenece ' },
      'ERROR_COMPANY_LATITUDE': { 'code': -1513, 'message': 'La latitud del parqueadero es requerido' },
      'ERROR_COMPANY_LONGITUDE': { 'code': -1514, 'message': 'La longitud es requerido' },
      'ERROR_COMPANY_ALTITUDE': { 'code': -1515, 'message': 'La altitud es requerido' },
      'ERROR_COMPANY_TELEPHONE': { 'code': -1516, 'message': 'El teléfono de la empresa es requerido' },
      'ERROR_COMPANY': { 'code': -1517, 'message': 'La información de la empresa, parqueadero o regional es requerido' },
      'ERROR_COMPANY_IDENTIFICATION': { 'code': -1518, 'message': 'La identificación de la empresa es requerido' },
      'ERROR_COMPANY_TYPE_IDENTIFICATION': { 'code': -1519, 'message': 'El tipo de identificación es requerido' },
      'ERROR_COMPANY_EMAIL': { 'code': -1520, 'message': 'Debe ingresar al menos un correo' },
      'ERROR_COMPANY_SELECT': { 'code': -1521, 'message': 'Debe seleccionar una empresa' },
      'ERROR_VEHICLE_INFO': { 'code': -1522, 'message': 'Se necesita la información el vehículo' },
      'ERROR_VEHICLE_PLATE': { 'code': -1523, 'message': 'La placa ó la identificación del vehículo es requerido' },
      'ERROR_VEHICLE_OWNER': { 'code': -1524, 'message': 'El propietario del vehículo es requerido' },
      'ERROR_VEHICLE_CLASSIFICATION': {
        'code': -1525,
        'message': 'El tipo del vehículo es requerida (Moto, Carro, Bicicleta)'
      },
      'ERROR_PROFILE_REQUIRED': { 'code': -1526, 'message': 'La información del perfil es requerido' },
      'ERROR_PROFILE_TITLE': { 'code': -1527, 'message': 'El título del perfil es requerido' },
      'ERROR_PROFILE_ENTITY': { 'code': -1528, 'message': 'La información de la empresa o persona es requerido' },
      'ERROR_ENTITY_IDENTIFICATION': {
        'code': -1529,
        'message': 'La identificación de la empresa o persona es requerido'
      },
      'ERROR_PROFILE_DELETE': { 'code': -1530, 'message': 'No se pudo eliminar el perfil' },
      'ERROR_PROFILE_CODE': { 'code': -1531, 'message': 'El identificador del perfil es requerido' },
      'ERROR_COMPANY_CODE': { 'code': -1532, 'message': 'El identificador del parqueadero o compañia es obligatorio' },
      'ERROR_PROPERTY_JSON': { 'code': -1533, 'message': 'No se pudo realizar la conversión del json' },
      'ERROR_METHOD_FRANCHISE': { 'code': -1534, 'message': 'Se debe de enviar el nombre de la franquicia ' },
      'ERROR_METHOD_IDENTIFICATION': { 'code': -1535, 'message': 'Se debe de enviar el número de la tarjeta' },
      'ERROR_METHOD_EXPIRATION': { 'code': -1536, 'message': 'Se debe de enviar la expiración de la tarjeta' },
      'ERROR_METHOD_NUMBER': { 'code': -1537, 'message': 'El número de verificación es obligatorio' },
      'ERROR_METHOD_FIND': { 'code': -1538, 'message': 'No se encontró el método de pago' },
      'ERROR_METHOD_CODE': { 'code': -1539, 'message': 'Debe seleccionar un método de pago' },
      'ERROR_VEHICLE_NOT_FOUND': { 'code': -1540, 'message': 'No se encontró el vehículo "__COMPLEMENT__"' },
      'ERROR_CALENDAR_INFO': { 'code': -1541, 'message': 'Debe enviar la información del calendario' },
      'ERROR_CALENDAR_DAY': { 'code': -1542, 'message': 'Debe seleccionar una fecha' },
      'ERROR_CALENDAR_COMPANY': { 'code': -1543, 'message': 'Debe seleccionar un parqueadero' },
      'ERROR_CALENDAR_CLASSIFICATION': { 'code': -1544, 'message': 'Debe seleccionar una clasificación para el día' },
      'ERROR_CALENDAR_ID': { 'code': -1545, 'message': 'No se ha recibido un id' },
      'ERROR_RESOLUTION_INITIAL_DATE': { 'code': -1546, 'message': 'Debe seleccionar una fecha inicial' },
      'ERROR_RESOLUTION_FINAL_DATE': { 'code': -1547, 'message': 'Debe seleccionar una fecha final' },
      'ERROR_RESOLUTION_FINAL_VALUE': { 'code': -1548, 'message': 'Debe ingresar el número final' },
      'ERROR_RESOLUTION_INITIAL_VALUE': { 'code': -1549, 'message': 'Debe ingresar el número inicial' },
      'ERROR_RESOLUTION_CURRENT_VALUE': { 'code': -1550, 'message': 'Debe ingresar el número actual' },
      'ERROR_RESOLUTION_VALUES': { 'code': -1551, 'message': 'Error en los valores de inicio, final y actual' },
      'ERROR_RESOLUTION': { 'code': -1552, 'message': 'Debe enviar la información de la resolución' },
      'ERROR_RESOLUTION_COMPANY': { 'code': -1553, 'message': 'Debe seleccionar una empresa' },
      'ERROR_RESOLUTION_DATE': { 'code': -1554, 'message': 'Fecha inicial no puede ser superior a la final' },
      'ERROR_RESOLUTION_ACTIVE': { 'code': -1555, 'message': 'Existe una resolución activa' },
      'ERROR_RESOLUTION_ID': {
        'code': -1556,
        'message': 'No se encontró la resolución, porfavor comuniquese con su administrador'
      },
      'ERROR_VOUCHER_TITLE': { 'code': -1557, 'message': 'El nombre del descuento es requerido' },
      'ERROR_VOUCHER': { 'code': -1558, 'message': 'La información del descuento es requerida' },
      'ERROR_VOUCHER_ID': { 'code': -1559, 'message': 'Debe ingresar el código del descuento' },
      'ERROR_VOUCHER_CLASSIFICATION': { 'code': -1560, 'message': 'La clasificación del descuento es requerido' },
      'ERROR_VOUCHER_COMPANY': { 'code': -1561, 'message': 'Debe seleccionar un parqueadero' },
      'ERROR_VOUCHER_NOT_FOUND': { 'code': -1562, 'message': 'No se encontró el descuento' },
      'ERROR_VOUCHER_EQUAL': { 'code': -1563, 'message': 'El código de descuento ya se encuentra registrado' },
      'ERROR_TARIFF_COMPANY': { 'code': -1564, 'message': 'Debe seleccionar un parqueadero' },
      'ERROR_TARIFF_ID': {
        'code': -1565,
        'message': 'Debe ingresar un identificador debe ser único para el tipo de vehículo y parqueadero'
      },
      'ERROR_TARIFF_TITLE': { 'code': -1566, 'message': 'Debe ingresar el nombre de la tarifa' },
      'ERROR_TARIFF_LOST_TICKET': { 'code': -1567, 'message': 'Debe ingresar el valor de périda de tiquete' },
      'ERROR_TARIFF_GRACE_TIME': { 'code': -1568, 'message': 'Debe ingresar el tiempo de gracia a la salida ' },
      'ERROR_TARIFF_SEGMENTS': { 'code': -1569, 'message': 'La tarifa debe de tener al menos un segmento' },
      'ERROR_TARIFF_SEGMENT_INITIAL_DAY': { 'code': -1570, 'message': 'Debe seleccionar el día inicial del segmento' },
      'ERROR_TARIFF_SEGMENT_FINAL_DAY': { 'code': -1571, 'message': 'Debe seleccionar el día final del segmento' },
      'ERROR_TARIFF_SEGMENT_INITIAL_HOUR': {
        'code': -1572,
        'message': 'Debe seleccionar el la hora inicial del segmento'
      },
      'ERROR_TARIFF_SEGMENT_FINAL_HOUR': { 'code': -1573, 'message': 'Debe seleccionar el la hora inicial del segmento' },
      'ERROR_TARIFF_SEGMENT_BLOCK_LIST': {
        'code': -1574,
        'message': 'Todos los segmentos debe tener al menos un bloque'
      },
      'ERROR_TARIFF_BLOCK_ID': { 'code': -1575, 'message': 'El bloque debe de tener un identificador' },
      'ERROR_TARIFF_BLOCK_TIME': { 'code': -1576, 'message': 'Debe especificar el tiempo en todos los bloques' },
      'ERROR_TARIFF_BLOCK_REPEAT': {
        'code': -1577,
        'message': 'Debe especificar la cantidad de veces que se repite el bloque'
      },
      'ERROR_TARIFF_BLOCK_VALUE': { 'code': -1578, 'message': 'El valor del bloque es obligatorio' },
      'ERROR_TARIFF': { 'code': -1579, 'message': 'La información de la tarifa es obligatoria' },
      'ERROR_DEVICE': { 'code': -1580, 'message': 'La información del dispositivo es obligatoria' },
      'ERROR_SLOT': { 'code': -1581, 'message': 'Debe enviar la información del lote' },
      'ERROR_SLOT_ID': { 'code': -1582, 'message': 'El id del lote es requerido y debe ser único para el parqueadero' },
      'ERROR_SLOT_TITLE': { 'code': -1583, 'message': 'Debe ingresar el nombre del lote' },
      'ERROR_SLOT_QUOTA': { 'code': -1584, 'message': 'Debe ingresar el cupo del lote' },
      'ERROR_SLOT_FOUND': { 'code': -1585, 'message': 'Ya existe un lote con el mismo código en el parqueadero' },
      'ERROR_SLOT_CODE': { 'code': -1586, 'message': 'Debe seleccionar un lote' },
      'ERROR_SLOT_NOT_FOUND': { 'code': -1587, 'message': 'No se encontró el lote' },
      'ERROR_DEVICE_ID': { 'code': -1588, 'message': 'Debe enviar un id del dispositivo' },
      'ERROR_SCHEDULE_TITLE': { 'code': -1589, 'message': 'Debe ingresar el ítulo del calendario' },
      'ERROR_SCHEDULE_DAYS': { 'code': -1590, 'message': 'Debe ingresar la información de los días' },
      'ERROR_SCHEDULE': { 'code': -1591, 'message': 'Debe ingresar la información del horario' },
      'ERROR_SCHEDULE_DAY_DAY': { 'code': -1592, 'message': 'Debe seleccionar el día' },
      'ERROR_SCHEDULE_DAY_INITIAL_HOUR': { 'code': -1593, 'message': 'Debe ingresar la hora inicial' },
      'ERROR_SCHEDULE_DAY_FINAL_HOUR': { 'code': -1594, 'message': 'Debe ingresar la hora final' },
      'ERROR_SCHEDULE_COMPANY': { 'code': -1595, 'message': 'Debe seleccionar un parqueadero' },
      'ERROR_SCHEDULE_ID': { 'code': -1596, 'message': 'Debe seleccionar un horario' },
      'ERROR_SCHEDULE_NOT_FOUND': { 'code': -1597, 'message': 'No se encontró el horario a eliminar' },
      'ERROR_SCHEDULE_MONTHLY': {
        'code': -1598,
        'message': 'El horario tiene mensuales registrados, por tal motivo no se puede eliminar'
      },
      'ERROR_INCOME_SETTING_COMPANY': {
        'code': -1599,
        'message': 'Debe seleccionar el parqueadero para poder realizar la configuración'
      },
      'ERROR_PAY_CONFIG': {
        'code': -1600,
        'message': 'Error al consultar la configuración de pago electrónico, por favor comunicarse con el administrador'
      },
      'ERROR_PAYU_BANKS': { 'code': -1601, 'message': 'Error al consultar los bancos en PAYU' },
      'ERROR_PAYU_METHODS': { 'code': -1602, 'message': 'Error al consultar los métodos de pago' },
      'ERROR_PAYU_CREATE_TOKEN': { 'code': -1603, 'message': 'Error al registrar la tarjeta de crédito' },
      'ERROR_PAY_CARD': { 'code': -1604, 'message': 'No se encontró la información de la tarjeta' },
      'ERROR_PAYU_REMOVE_TOKEN': { 'code': -1605, 'message': 'Error al eliminar la tarjeta en PAYU' },
      'ERROR_PAYU_PAY_SERVICE': { 'code': -1606, 'message': 'Error al procesar el pago con la pasarela' },
      'ERROR_INCOME_SPECIAL_COMPANY': { 'code': -1607, 'message': 'Debe seleccionar una empresa o parqueadero' },
      'ERROR_INCOME_SPECIAL_ENTITY': { 'code': -1608, 'message': 'Debe seleccionar una persona o tercero' },
      'ERROR_INCOME_SPECIAL_QUOTA': {
        'code': -1609,
        'message': 'Debe ingresar el número de vehículos que la persona puede ingresar simultáneamente'
      },
      'ERROR_INCOME_SPECIAL_SLOT': { 'code': -1610, 'message': 'Debe seleccionar el lote' },
      'ERROR_INCOME_SPECIAL_SCHEDULE': { 'code': -1611, 'message': 'Debe seleccionar un horario' },
      'ERROR_INCOME_SPECIAL_LIQUIDATION': { 'code': -1612, 'message': 'Debe seleccionar la liquidación' },
      'ERROR_INCOME_SPECIAL_VEHICLE': { 'code': -1613, 'message': 'Debe agregar al menos un vehículo' },
      'ERROR_INCOME_SPECIAL_VEHICLE_INFO': { 'code': -1614, 'message': 'Debe enviar la información del vehículo' },
      'ERROR_INCOME_SETTING': { 'code': -1615, 'message': 'No se encontró el registro' },
      'ERROR_KIND': { 'code': -1616, 'message': 'Debe enviar la clase que quiere consultar' },
      'ERROR_PAYU_QUERY_TRANSACTION': { 'code': -1617, 'message': 'Error al consultar la transacción' },
      'ERROR_PAY_QUERY_TRANSACTION': { 'code': -1618, 'message': 'Error al consultar la transacción' },
      'ERROR_COMPANY_LOCATION': { 'code': -1619, 'message': 'Error el parqueadero no tiene una ubicación' },
      'ERROR_COMPANY_NOT_FOUND_MAIN': {
        'code': -1620,
        'message': 'Error al consultar la empresa principal del parqueadero'
      },
      'ERROR_STORE_TITLE': { 'code': -1621, 'message': 'Debe ingresar el nombre de la tienda' },
      'ERROR_STORE_STREET_NUMBER': { 'code': -1622, 'message': 'Debe ingresar el número de la calle' },
      'ERROR_STORE_STREET_NAME': { 'code': -1623, 'message': 'Debe ingresar el nombre de la calle' },
      'ERROR_STORE_CODE': { 'code': -1624, 'message': 'Debe seleccionar una tienda' },
      'ERROR_STORE_NOT_FOUND': { 'code': -1625, 'message': 'No se encontró la tienda' },
      'ERROR_STORE_MPID': { 'code': -1626, 'message': 'Debe enviar el identificador de mercado pago' },
      'ERROR_POS_TITLE': { 'code': -1627, 'message': 'el nombre de la caja debe ser requerido' },
      'ERROR_POS_EXTERNAL_ID': {
        'code': -1628,
        'message': 'Debe ingresar el identificador de la caja para mercado pago'
      },
      'ERROR_POS_CODE': { 'code': -1629, 'message': 'Debe seleccionar una caja' },
      'ERROR_POS_MP_ID': { 'code': -1630, 'message': 'Se debe enviar el identificador de mercado pago' },
      'ERROR_INVOICE_SUBTOTAL': { 'code': -1631, 'message': 'El subtotal es obligatorio' },
      'ERROR_INVOICE_TAX': { 'code': -1632, 'message': 'Se debe especificar el valor del impuesto' },
      'ERROR_INVOICE_TOTAL': { 'code': -1633, 'message': 'El valor total es requerido' },
      'ERROR_INVOICE_PREFIX': { 'code': -1634, 'message': 'El prefijo de la factura es requerido' },
      'ERROR_INVOICE_ENTITY': {
        'code': -1635,
        'message': 'La identificación del cliente es requerido'
      },
      'ERROR_INVOICE_DETAILS': {
        'code': -1636,
        'message': 'Los detalles de la factura son obligatorios'
      },
      'ERROR_INVOICE_CONCEPT_INITIALS': {
        'code': -1637,
        'message': 'La sigla del concepto es requerido'
      },
      'ERROR_INVOICE_CONCEPT_QUANTITY': {
        'code': -1638,
        'message': 'La cantidad del detalle es requerido'
      },
      'ERROR_INVOICE_CONCEPT_UNIT_VALUE': {
        'code': -1639,
        'message': 'El valor unitario del detalle es requerido'
      },
      'ERROR_INVOICE_CONCEPT_TOTAL': {
        'code': -1640,
        'message': 'El valor total del detalle es requerido'
      },
      'ERROR_CONCEPT_NOT_FOUND': {
        'code': -1641,
        'message': 'No se encontró el concepto con sigla __COMPLEMENT__'
      },
      'ERROR_CONCEPT_NOT_FOUND_BY_TITLE': {
        'code': -1642,
        'message': 'No se encontró el concepto con el nombre: __COMPLEMENT__'
      },
      'ERROR_INVOICE_NOT_FOUND': {
        'code': -1643,
        'message': 'La factura no fue encontrada "__COMPLEMENT__"'
      },
      'ERROR_PAYMENT_REQUEST': {
        'code': -1644,
        'message': 'Error al realizar la consulta a mercado pago'
      },
      'ERROR_TARIFF_CODE': {
        'code': -1645,
        'message': 'Error, no se ha recibido un código válido de tarifa'
      },
      'ERROR_INVOICE_INFO': {
        'code': -1646,
        'message': 'Se necesita la información el invoice'
      },
      'ERROR_NEXT_BLOCK': {
        'code': -1647,
        'message': 'El valor de siguiente del bloque es obligatorio'
      },
      'ERROR_TARIFF_BLOCK_NEXT': {
        'code': -1648,
        'message': 'El valor de siguiente de uno de los bloques no es válido.'
      },
      'ERROR_TARIFF_BLOCK_CODE': {
        'code': -1649,
        'message': 'El valor del código de uno de los bloques está repetido.'
      },
      'ERROR_CONCEPTS_CATEGORY_CONFIG': {
        'code': -1650,
        'message': 'La categoría de conceptos no ha sido configurada.'
      },
      'ERROR_CONCEPT_UPDATED': {
        'code': -1651,
        'message': 'Concepto actualizado por otro usuario, debe obtener los últimos cambios.'
      },
      'ERROR_LIQUIDATION_NO_EXIST': {
        'code': -1652,
        'message': 'Liquidación no existe.'
      },
      'ERROR_LIQUIDATION_CONCURRENCY': {
        'code': -1653,
        'message': 'Otro usuario ha actualizado el registro.'
      },
      'ERROR_IDENTIFICATION_REQUIRED': {
        'code': -1654,
        'message': 'Error, la identificación es requerida.'
      },
      'ERROR_INCOME_SPECIAL_LIQUIDATION_NOT_FOUND': {
        'code': -1655,
        'message': 'No existe una liquidación para la compañia __COMPLEMENT__'
      },
      'ERROR_SLOT_MAIN_COMPANY_NOT_FOUND': {
        'code': -1656,
        'message': 'No existe un lote principal para la compañia '
      },
      'ERROR_GRACE_OUT_TIME': {
        'code': -1657,
        'message': 'Error, el tiempo de gracias de la salida es requerido.'
      },
      'ERROR_FILE_IS_EMPTY': {
        'code': -1658,
        'message': 'Error, no se ha recibido un archivo.'
      },
      'ERROR_SLOT_COMPANY_MAIN': {
        'code': -1659,
        'message': 'No se admiten más de dos lotes  __COMPLEMENT__'
      },
      'ERROR_CATEGORY_LIQUIDATIONS': {
        'code': -1660,
        'message': 'No existe una categoria de liquidación'
      },
      'ERROR_SCHEDULE_MONTHLY_COMPANY': {
        'code': -1661,
        'message': 'La empresa  __COMPLEMENT__ no tiene un horario asignado para mensuales'
      },
      'ERROR_MACHINE_COMPANY_NOT_FOUND': {
        'code': -1662,
        'message': 'La empresa  __COMPLEMENT__ no tiene un dispositvio de caja manual asociado'
      },
      'ERROR_ENTITY_GENERIC': {
        'code': -1663,
        'message': 'Error al buscar tercero default, por favor crearlo como "__COMPLEMENT__" con id 111'
      },
      'ERROR_VEHICLE_PLATE_NO_FORMAT': {
        'code': -1664,
        'message': 'La placa del vehículo tiene un formato no válido se excluye el registro'
      },
      'ERROR_CONCEPT_FIREBIRD': {
        'code': -1665,
        'message': 'Faltán conceptos para la liquidación de firebird por favor parametrizar __COMPLEMENT__'
      },
      'ERROR_INVOICE_DETAIL_INSERT': {
        'code': -1666,
        'message': 'Error, no se encontró el concepto para el código "__COMPLEMENT__"'
      },
      'ERROR_INVOICE_PREFIX_BILL': {
        'code': -1667,
        'message': 'Error, por favor verificar que hay un número de fáctura diferente a 0 y un prefijo válido'
      },
      'ERROR_INVOICE_DETAIL_CONCEPT': {
        'code': -1668,
        'message': 'Error, no hay una opción válida para seguir el proceso de fáctura detalle (invalid_concept)'
      },
      'ERROR_ENTITY': {
        'code': -1669,
        'message': 'Error entidad'
      },
      'ERROR_ENTITY_NO_FOUND': {
        'code': -1670,
        'message': 'Error, no existe el usuario'
      },
      'ERROR_ENTITY_NO_FOUND_ACCESS': {
        'code': -1671,
        'message': 'Error, el usuario no tiene un acceso valido, el usuario __COMPLEMENT__ no existe'
      },
      'ERROR_VEHICLE_MONTHLY': {
        'code': -1672,
        'message': 'Error, El vehiculo __COMPLEMENT__ está registrado en más de una mensualidad'
      },
      'ERROR_CARD_ID_REPLY': {
        'code': -1673,
        'message': 'Error, el código de compañia y parqueadero (cardId) lo está usando otra compañia'
      },
      'ERROR_TITLE_ACCOUNT': {
        'code': -1674,
        'message': 'Error, el título de la cuenta no puede ser nulo'
      },
      'ERROR_USUCODIGO_REQUIRED': {
        'code': -1675,
        'message': 'Error, usucodigo es requerido'
      },
      'ERROR_PREFIX_REPLY': {
        'code': -1676,
        'message': 'Error, el prefijo ya ha sido utilizado.'
      },
      'ERROR_USUCODIGO_REPLY': {
        'code': -1677,
        'message': 'Error, el usucodigo ya ha sido utilizado.'
      },
      'ERROR_SLOT_UNDEFINED': {
        'code': -1678,
        'message': 'Error, lote indefinido.'
      },
      'ERROR_SLOT_PRINCIPAL_REPLY': {
        'code': -1679,
        'message': 'Error, ya existe un lote principal en esta compañia.'
      },
      'ERROR_TARIFF_CODE_REPLY': {
        'code': -1680,
        'message': 'Error, ya existe una tarifa con el código ingresado.'
      },
      'ERROR_DEVICE_NAME_REPLY': {
        'code': -1681,
        'message': 'Error, ya existe un dispositivo con este nombre.'
      },
      'ERROR_USER_ENTITY': {
        'code': -1682,
        'message': 'Error, no existe el usuario.'
      },
      'ERROR_CONCEPT_TITLE_REPLY': {
        'code': -1683,
        'message': 'Error, ya existe un concepto con el mismo nombre.'
      },
      'ERROR_LIQUIDATION_CONCEPT': {
        'code': -1684,
        'message': 'Error, No se encontraron liquidacion conceptos'
      },
      'ERROR_ENTITY_EXIST': {
        'code': -1685,
        'message': 'El correo electrónico o su identificacion ya existe'
      },
      'ERROR_CATEGORY_NOT_FOUND': {
        'code': -1686,
        'message': 'Error al encontrar la categoría'
      },
      'ERROR_REPORT_DOWNLOAD': {
        'code': -1687,
        'message': 'Error al generar el reporte'
      },
      'ERROR_PARAMS_ACCESS_QUERY': {
        'code': -1688,
        'message': 'Error deve enviar un código de acceso (code) o un código de entidad (entityCode)'
      },
      'ERROR_MOVEMENT_NOT_FOUND': {
        'code': -1689,
        'message': 'Error al encontrar el movimiento "__COMPLEMENT__"'
      },
      'ERROR_DETAIL_NOT_FOUND': {
        'code': -1690,
        'message': 'Error al encontrar detalles de factura'
      },
      'ERROR_DETAILS_NOT_FOUND': {
        'code': -1691,
        'message': 'Error al encontrar detalle de factura  "__COMPLEMENT__"'
      },
      'OMIT_LIQUIDATION': {
        'code': -1692,
        'message': 'Error, Liquidación "__COMPLEMENT__" no válida.'
      },
      'ERROR_LIQUIDATION_MOVEMENTS': {
        'code': -1693,
        'message': 'Error, la liquidación no cuenta con un movimiento disponible'
      },
      'ERROR_LIQUIDATION_MULTIPLE_MOVEMENTS': {
        'code': -1694,
        'message': 'Error, la liquidación cuenta con más de un movimiento'
      },
      'ERROR_PAY_METHOD_NOT_FOUND': {
        'code': -1695,
        'message': 'Error, el método de pago "__COMPLEMENT__" no existe.'
      },
      'ERROR_VEHICLE_TYPE_NOT_FOUND': {
        'code': -1696,
        'message': 'Error, el tipo de vehículo "__COMPLEMENT__" no existe.'
      },
      'ERROR_DEVICE_ENTRY_NOT_FOUND': {
        'code': -1697,
        'message': 'Error, el dispositivo de entrda "__COMPLEMENT__" no existe.'
      },
      'ERROR_ROLLBACK_DATE_INVOICE': {
        'code': -1698,
        'message': 'Error la fecha de anulación de factura es inválida __COMPLEMENT__'
      },
      'ERROR_DEVICE_TITLE': {
        'code': -1699,
        'message': 'Error, no se pudo obtener el nombre del dispositivo (ip) __COMPLEMENT__'
      },
      'ERROR_PERMISSIONS': {
        'code': -1700,
        'message': 'No tienes permisos suficientes para realizar esta operación'
      },
      'ERROR_VALUE_INCOMESPECIAL': {
        'code': -1701,
        'message': 'Error, valor del mensual no puede ser 0'
      },
      'ERROR_EMAIL_USED': {
        'code': -1702,
        'message': 'Error, el email ya se encuentra registrado'
      },
      'ERROR_EMAIL_EDIT': {
        'code': -1703,
        'message': 'Edito un email ya registrado'
      },
      'ERROR_TITLE_UNITY_USED': {
        'code': -1704,
        'message': 'Este nombre de unidad ya ha sido usado antes'
      },
      'ERROR_CODE_UNITY_USED': {
        'code': -1705,
        'message': 'Este nombre de unidad ya ha sido usado antes'
      },
      'ERROR_METHOD_PAY_PROPERTY_USED': {
        'code': -1706,
        'message': 'Este método de pago ya ha sido configurado antes'
      },
      'ERROR_IMEI': {
        'code': -1707,
        'message': 'Error, Imei es requerido '
      },
      'ERROR_DEVICE_EXIST': {
        'code': -1708,
        'message': 'Error, Dispositivo no existe, por favor comuníquese con su administrador'
      },
      'ERROR_METHOD_NOT_SUPPORTED': {
        'code': -1709,
        'message': 'Error, El método http no es soportado'
      },
      'ERROR_VEHICLE_DETAIL_NOT_FOUND': {
        'code': -1710,
        'message': 'No se encontró el vehículo "__COMPLEMENT__"'
      },
      'ERROR_METHOD_LOGIC': {
        'code': -1711,
        'message': 'El método tiene un error de lógica'
      },
      'ENUMERATION_NOT_FOUND': {
        'code': -1712,
        'message': 'Error no se encuentra la resolución '
      },
      'ERROR_INCOME_SPECIAL_NOT_FOUND': {
        'code': -1713,
        'message': 'Error no se encontró el mensual'
      },
      'ERROR_INCOME_TYPE': {
        'code': -1714,
        'message': 'Error al procesar el tipo de mensualidad'
      },
      'ERROR_ACCESS_NULL': {
        'code': -1715,
        'message': 'Error la información del access es requerida'
      },
      'ERROR_INVOICE_INFO_ID': {
        'code': -1716,
        'message': 'Error ,no existe la identificación de la factura'
      },
      'ERROR_INCOME_SPECIAL_ITEM': {
        'code': -1717,
        'message': 'Debe agregar al menos un artículo'
      },
      'ERROR_INCOME_SPECIAL_STATUS': {
        'code': -1718,
        'message': 'El estado del abonado es obligatorio'
      },
      'ERROR_INCOME_SPECIAL_ITEM_FOUND': {
        'code': -1718,
        'message': 'El identificador del vehículo o artículo ya está en uso: __COMPLEMENT__'
      },
      'ERROR_INCOME_ITEM': {
        'code': -1719,
        'message': 'Hay números de tarjeta duplicados para un mismo servicio por favor validar la información'
      },
      'ERROR_INCOME_ITEM_NOT_FOUND': {
        'code': -1720,
        'message': 'Lo sentimos el articulo a almacenar no es valido'
      },
      'ERROR_LOCKER_DETAIL_ID': {
        'code': -1719,
        'message': 'Error, no existe un movimiento de casillero valido'
      },
      'ERROR_LOCKER_DETAIL_NOT_FOUND': {
        'code': -1718,
        'message': ' Error,no obtiene detalle del locker '
      },
      'ERROR_LIST_INCOME_ITEM': {
        'code': -1720,
        'message': 'Error, lista de item del mensual esta vacia'
      },
      'ERROR_INCOME_SERVICE': {
        'code': -1721,
        'message': 'Error, Servicio de abonado no obtenido '
      },
      'ERROR_LOCKER_ID': {
        'code': -1722,
        'message': 'Error, el codigo del locker no fue encontrado'
      },
      'ERROR_TOKEN_CORRUPT': {
        'code': -1723,
        'message': 'El token está mal construido'
      },
      'ERROR_CARD': {
        'code': -1724,
        'message': 'El número de la tarjeta es obligatorio'
      },
      'ERROR_CONSECUTIVE': {
        'code': -1725,
        'message': 'El número consecutivo es obligatorio'
      },
      'ERROR_VEHICLE_TYPE': {
        'code': -1726,
        'message': 'El tipo de vehículo es obligatorio'
      },
      'ERROR_URL_REQUIRED': {
        'code': -1727,
        'message': 'Error la url es obligatoria'
      },
      'ERROR_EMAIL_EXITS': {
        'code': -1728,
        'message': 'Error el correo electrónico ya existe'
      },
      'ERROR_DELETE_INCOME_ITEM': { 'code': -1729, 'message': 'Error, eliminando item del mensual' },
      'ERROR_LIST_INCOME_SERVICE': { 'code': -1730, 'message': 'Error, No se encontro lista de servicios del mensual' },
      'ERROR_DEPOSIT_TOTAL': { 'code': -1731, 'message': 'Error el total del deposito es requerido' },
      'ERROR_DEPOSIT_DATE': { 'code': -1732, 'message': 'Error la fecha del deposito es requerida ' },
      'ERROR_DEPOSIT_COMPANY': { 'code': -1733, 'message': 'Error la compañia del deposito es requerida' },
      'ERROR_DEPOSIT_DETAIL_DEVICE': { 'code': -1734, 'message': 'Error el dispositivo del detalle es requerido' },
      'ERROR_TOTAL_DEPOSIT_DETAIL': { 'code': -1735, 'message': 'Error el total del detalle es requerido' },
      'ERROR_DEPOSIT': { 'code': -1736, 'message': 'Error el deposito del detalle es requerido' },
      'ERROR_FINANCE_DEVICE': { 'code': -1737, 'message': 'Error dispositivo del financeReport es requerido' },
      'ERROR_FINANCE_INITIAL_BILL': { 'code': -1738, 'message': 'Error factura inicial es requerida de financeReport' },
      'ERROR_FINANCE_FINAL_BILL': { 'code': -1739, 'message': 'Error factura final es requerida de financeReport' },
      'ERROR_FINANCE_TOTAL_BILL': {
        'code': -1740,
        'message': 'Error total facturas emitidas es requerido de financeReport'
      },
      'ERROR_FINANCE_COMPANY': { 'code': -1741, 'message': 'Error compañia de financeReport es requerida' },
      'ERROR_FINANCE_INVOICED': { 'code': -1742, 'message': 'Error  total facturado es requerido de financeReport' },
      'ERROR_FINANCE_ELECTRONIC_PAY': {
        'code': -1743,
        'message': 'Error pago electronico es requerido de financeReport'
      },
      'ERROR_FINANCE_AMOUNT_COLLECTED': {
        'code': -1744,
        'message': 'Error importe de recaudo es requerido de financeReport'
      },
      'ERROR_FINANCE_DETAIL': {
        'code': -1745,
        'message': 'Error  el detalle del deposito es requerido de financeReport'
      },
      'ERROR_FINANCE_EVENTS_REFUNDS': {
        'code': -1746,
        'message': 'Error catidad de retornares es requerido de financeReport'
      },
      'ERROR_FINANCE_REFUNDS_VALUE': {
        'code': -1747,
        'message': 'Error valor de los retornares es requerido de financeReport'
      },
      'ERROR_SAVE_SLOTDETAIL': { 'code': -1748, 'message': 'Error al guardar el detalle del lote' },
      'ERROR_SPACE_NOT_AVAILABLE': {
        'code': -1749,
        'message': 'No hay espacio disponible, para los criterios seleccionados'
      },
      'ERROR_LOCATION_PREVIOUS': { 'code': -1750, 'message': 'Error al encontrar el espacio previo' },
      'ERROR_FINANCE_SUBTOTAL_INVOICED': {
        'code': -1751,
        'message': 'Error  subtotal facturado es requerido de financeReport'
      },
      'ERROR_METHOD_NOT_FOUND_INVOICE': {
        'code': -1752,
        'message': 'No se encontró pagos para la factura __COMPLEMENT__'
      },
      'ERROR_MOVEMENT_CONSECUTIVE': { 'code': -1753, 'message': 'Error, el movimiento no tiene consecutivo ' },
      'ERROR_MOVEMENT_ENTRY_DATE': { 'code': -1754, 'message': 'Error, el movimiento no tiene una fecha de ingreso' },
      'ERROR_SPACE_TO_FREE': { 'code': -1755, 'message': 'Error al tratar de liberar espacio' },
      'ERROR_FREQUENCY_TITLE': { 'code': -1756, 'message': 'Error titulo o nombre de la frecuencia es requerido' },
      'ERROR_FREQUENCY_TIME': { 'code': -1757, 'message': 'Error tiempo de intervalo es requerido en la frecuencia' },
      'ERROR_FRECUENCY_INTERVAL': { 'code': -1758, 'message': 'Error intervalo de frecuencia es requerido' },
      'ERROR_SETTING_REPORT': { 'code': -1759, 'message': 'Error codigo de configuracion de envio es requerido' },
      'ERROR_FREQUENCY': { 'code': -1760, 'message': 'Error frecuencia de envio es requerida' },
      'ERROR_ADDRESSEE': { 'code': -1761, 'message': 'Error destinatario de envio es obligatorio' },
      'ERROR_TYPE_REPORT': { 'code': -1762, 'message': 'Error tipo de formato es requerido para el envio' },
      'ERROR_NEXT_RUN_DATE': { 'code': -1763, 'message': 'Error fecha de proximo envio es requerida' },
      'ERROR_APP_SETTING': { 'code': -1764, 'message': 'Error app del reporte es requerida' },
      'ERROR_PARAMS_REQUIRED': { 'code': -1765, 'message': 'Error parametros de reporte requeridos' },
      'ERROR_API_SETTING': { 'code': -1766, 'message': 'Error API del reporte es requerida' },
      'ERROR_TOKEN': { 'code': -1767, 'message': 'Error informacion del token requerida' },
      'ERROR_SHIPPING_DATE': { 'code': -1768, 'message': 'Error fecha de envio es requerida' },
      'ERROR_SEND_EMAIL': { 'code': -1769, 'message': 'Error codigo se envio es requerido' },
      'ERROR_SHIPPING_STATUS': { 'code': -1770, 'message': 'Error estado del envio es requerido' },
      'ERROR_DESCRIPTION': { 'code': -1771, 'message': 'Error descripcion del envio es requeridad' },
      'ERROR_MOVEMENT': { 'code': -1772, 'message': 'Error el movimiento es requerido' },
      'ERROR_RECORD_ID': { 'code': -1773, 'message': 'Error, sin identificador del registro' },
      'ERROR_RECOD_TYPE': { 'code': -1774, 'message': 'Error, sin tipo de registro' },
      'ERROR_ID_INVOICE': { 'code': -1775, 'message': 'Error, el identificador unico de la factura es requerido' },
      'ERROR_ID_INVOICE_DETAIL': {
        'code': -1776,
        'message': 'Error, el identificador unico del detalle de la factura es requerido'
      },
      'ERROR_ID_INVOICE_INFO': {
        'code': -1777,
        'message': 'Error, el identificador unico de la informacion de la factura es requerido'
      },
      'ERROR_ID_PAYMENT': { 'code': -1778, 'message': 'Error, el identificador unico del pago es requerido' },
      'ERROR_ID_PAYMENT_DETAIL': {
        'code': -1779,
        'message': 'Error, el identificador unico de los detalles del pago son requiridos'
      },
      'ERROR_INTEGRATION_COMPANY': {
        'code': -1780,
        'message': 'Error , la compañía de la integración de software  contable es requerida'
      },
      'ERROR_INTEGRATION_TYPE': { 'code': -1781, 'message': 'Error , el tipo de integración contable es requerido' },
      'ERROR_INTEGRATION_INFO': { 'code': -1782, 'message': 'Error, la configuracion de la integración es requerida' },
      'ERROR_INITIAL': { 'code': -1783, 'message': 'Error la inicial de la unidad es requerida' },
      'ERROR_DEVICES': { 'code': -1784, 'message': 'Error la información de los dispositivos es requerida' },
      'ERROR_DATE_REQUIRED': { 'code': -1785, 'message': 'Debe seleccionar  la fecha inicial y/o la fecha final' },
      'ERROR_INCORRECT_DATE_FORMAT': { 'code': -1786, 'message': 'Las fechas no cumplen con el formato yyyy-mm-dd' },
      'ERROR_RANGE_DATE': { 'code': -1787, 'message': 'Error, la fecha inicial no puede ser superior a la fecha final' },
      'ERROR_RANGE_MAX_DAY': {
        'code': -1788,
        'message': 'El rango de fechas supera el máximo permitido. Máximo de dias __COMPLEMENT__'
      },
      'ERROR_FINAL_DATE': { 'code': -1789, 'message': 'La fecha final no puede ser superior a la fecha actual' },
      'ERROR_CRITERIA_NOT_FOUND': { 'code': -1790, 'message': 'Debe seleccionar criterios de busqueda' },
      'ERROR_INVOICE_LIST_CANCELED': { 'code': -1791, 'message': 'Error, debe haber almenos una factura para anular' },
      'ERROR_DESCRIPTION_CANCELED': {
        'code': -1792,
        'message': 'Error, se debe agragar una descrición a la anulación de facturación'
      },
      'ERROR_LOCKER_DETAIL_TYPE': {
        'code': -1793,
        'message': 'Error, no existe un tipo de evento para el detalle del casillero '
      },
      'ERROR_VOUCHER_DETAIL_INSTANT': { 'code': -1794, 'message': 'Error,la fecha de uso del descuento es requerida' },
      'ERROR_INCOME_ITEM_IDETIFICATION_DUPLICATE': {
        'code': -1795,
        'message': 'Lo sentimos el número de tarjeta no se puede duplicar cuando su pago es individual. __COMPLEMENT__ '
      },
      'ERROR_INCOME_SPECIAL': { 'code': -1796, 'message': 'Error, el abonado es requerido' },
      'ERROR_INCOME_SERVICE_TYPE': {
        'code': -1721,
        'message': 'Error,el Servicio de abonado debe tener un tipo definido'
      },
      'ERROR_INCOME_SERVICE_TYPE_DUPLICATE': {
        'code': -1721,
        'message': 'Error,el tipo  de Servicio ESyncMessagedel abonado se encuentra duplicado'
      },
      'ERROR_INCOME_SERVICE_NOT_FOUND': { 'code': -1722, 'message': 'Error, el abonado requiere almenos un servicio' },
      'ERROR_INCOME_SPECIAL_CARD_DUPLICATE': {
        'code': -1723,
        'message': 'Error,el numero de tarjeta o tag __COMPLEMENT__ se encuentra duplicado, debera cambiar numero de tarjeta'
      },
      'ERROR_INCOME_SPECIAL_CARD_USED': {
        'code': -1723,
        'message': 'Error,el numero de tarjeta o tag __COMPLEMENT__ ya se encuentra asignado'
      },
      'ERROR_INCOME_ITEM_SHIP_ID_DUPLICATE': {
        'code': -1795,
        'message': 'Lo sentimos el, números del tag no se puede duplicar cuando su pago es individual '
      },
      'ERROR_INCOME_SETTING_NOT_FOUND': {
        'code': -1796,
        'message': ' Error, no se encontró configuración general de abonados '
      },
      'ERROR_FIND_SLOTDETAIL': { 'code': -1797, 'message': 'Error al buscar detalle del lote' },
      'ERROR_SELECT_SLOT': { 'code': -1798, 'message': 'no se puede seleccionar cupo del lote' },
      'ERROR_ENUMERATION_PREFIX_NOT_FOUND': {
        'code': -1799,
        'message': 'Error la resolucion con el prefijo __COMPLEMENT__ no existe,comunicate con el administrador '
      },
      'ERROR_INCOME_SPECIAL_MANY_CARD_USED': { 'code': -1800, 'message': 'Hay número de tarjeta duplicados' },
      'ELECTRONIC_ERROR_INVOICE_SYNC': { 'code': -1801, 'message': 'Error al sincronizar la factura' },
      'ERROR_SERVICE_LIQUIDATOR': { 'code': -1800, 'message': 'Error el microservicio liquidador no responde' },
      'ERROR_PARAM_LIQUIDATOR': { 'code': -1801, 'message': 'Parametro de entrada para liquidacion de requerida' },
      'ERROR_URL_GATEWAY': { 'code': -1802, 'message': 'debe configurar URL gateway en archivo yml' },
      'ERROR_MOVEMENT_CHECK_OUT': {
        'code': -1803,
        'message': 'Lo sentimos, el vehículo ya no se encuentra en parqueadero, su salida fue realizada __COMPLEMENT__'
      },
      'ERROR_EMAIL_ENTITY_NULL': { 'code': -1803, 'message': 'El usuario no posee correo electónico' },
      'ERROR_NAMES_ENTITY_NULL': {
        'code': -1804,
        'message': 'El usuario no posse datos de nombre y/o apellido completos'
      },
      'ERROR_AGREEMENT_ENTITY_NULL': {
        'code': -1805,
        'message': 'El usuario no posee aceptación de términos y condiciones'
      },
      'ERROR_ENTITY_NO_REGISTER': { 'code': -1806, 'message': 'El usuario no esta registrado' },
      'ERROR_NAME_ENTITY_NULL': { 'code': -1807, 'message': 'El usuario no posse datos de nombre' },
      'ERROR_UNITY_ENTITY_NULL': { 'code': -1808, 'message': 'La unidad de la Entidad es requerida' },
      'ERROR_UNITY_NOT_FOUND': { 'code': -1809, 'message': 'Lo sentimos, unidad no encontrada' },
      'ERROR_IDENTIFICATION_BLANK': {
        'code': -8008,
        'message': 'El número de identificación no puede estar vacío ó debe contener al menos 5 dígitos'
      },
      'ERROR_MOVEMENT_SUBSCRIBER_NOT_FOUND': {
        'code': -8009,
        'message': 'Error al encontrar el movimiento del abonado con identificación "__COMPLEMENT__"'
      },
      'ERROR_ENVIRONMENT_SEND_REPORTS_MAIL': {
        'code': -1810,
        'message': 'Error el valor del environment es requerido en la generación automatica del reporte'
      },
      'ERROR_USED_PASSWORD': {'code': -2508, 'message': 'La contraseña ya ha sido utilizada antes, por favor ingresa una nueva'},
    },
    ENotice: {
      //Test
      'PERSON_ERROR_AGE': 'La edad de la persona no es válida.',
      'PERSON_ERROR_NAME': 'El nombre de la persona es obligatorio o no válido.',
      'PERSON_ERROR_NAME_SIZE': 'El nombre de la persona excede el tamaño permitido.',
      'PERSON_ERROR_SURNAME': 'El apellido de la persona es obligatorio o no válido.',
      'PERSON_NOT_FOUND': 'La persona no fue encontrada.',
      //End-Test
  
      //ReportUtil
      'FORMAT_NOT_EXISTS': 'El formato solicitado no existe.',
      'FILE_NOT_FOUND': 'El archivo no fue encontrado.',
  
      //Global
      'GLOBAL_ERROR_COMPANY_REQUIRED': 'La empresa es obligatoria.',
      'GLOBAL_ERROR_DATE_FROM_REQUIRED': 'La fecha de inicio es obligatoria.',
      'GLOBAL_ERROR_DATE_TO_REQUIRED': 'La fecha de fin es obligatoria.',
      //EndGlobal

      //Security
      'SECURITY_ERROR_ACCESS_INFO_NOT_FOUND': 'No se encontró la información del acceso',
      'SECURITY_ERROR_PASSWORD_REUSED': 'La contraseña ya ha sido utilizada antes, por favor ingresa una nueva',
      'GLOBAL_ERROR_CURRENT_PASSWORD_MISMATCH': 'La contraseña actual no coincide con la registrada',
  
      //BillingConcept
      'BILLING_CONCEPT_ERROR_QUERY_WAY': 'La forma de consulta no es válida para el concepto de facturación.',
      'BILLING_CONCEPT_ERROR_CRITERIA': 'Los criterios de búsqueda no son válidos para el concepto de facturación.',
      'BILLING_CONCEPT_ERROR_QUERY_STATION': 'La estación de consulta no es válida para el concepto de facturación.',
      'BILLING_CONCEPT_ERROR_SEARCH': 'Ocurrió un error al buscar los conceptos de facturación.',
      'BILLING_CONCEPT_ERROR_SUMMARY': 'No se pudo generar el resumen de los conceptos de facturación.',
      'BILLING_CONCEPT_NOT_FOUND': 'No se encontraron conceptos de facturación.',
      'BILLING_CONCEPT_CREATE_REPORT': 'No se pudo generar el informe de conceptos de facturación.',
      'BILLING_CONCEPT_ID_REQUIRED': 'El ID del concepto de facturación es obligatorio.',
      'BILLING_CONCEPT_SAVE': 'El concepto de facturación fue guardado correctamente.',
      'MOVEMENT_ERROR_NOT_FOUND': 'El movimiento no fue encontrado.',
  
      //IncomeMovement
      'INCOME_MOVEMENT_ID_REQUIRED': 'El ID del movimiento de ingreso es obligatorio.',
      'INCOME_MOVEMENT_ERROR_CRITERIA': 'Los criterios de búsqueda para movimientos de ingreso no son válidos.',
      'INCOME_MOVEMENT_ERROR_SEARCH': 'Ocurrió un error al buscar los movimientos de ingreso.',
      'INCOME_MOVEMENT_ERROR_SUMMARY': 'No se pudo generar el resumen de los movimientos de ingreso.',
      'INCOME_MOVEMENT_NOT_FOUND': 'No se encontraron movimientos de ingreso.',
      'INCOME_MOVEMENT_CREATE_REPORT': 'No se pudo generar el informe de movimientos de ingreso.',
      'INCOME_MOVEMENT_TARIFF_QUERY': 'Error al consultar la tarifa del movimiento de ingreso.',
      //EndBillingConcept
  
      //Note
      'NOTE_ERROR_QUERY_ID': 'El ID de la nota para la consulta es inválido o no fue proporcionado.',
      //EndNote
      //NoteDetail
      'NOTE_DETAIL_ERROR_QUERY_NOTE': 'La nota relacionada no fue encontrada o es inválida.',
      //EndNoteDetail
  
      //DetailedCollection
      'DETAILED_COLLECTION_ERROR_CRITERIA': 'Los criterios para la colección detallada no son válidos.',
      'DETAILED_COLLECTION_ERROR_SEARCH': 'Ocurrió un error al buscar la colección detallada.',
      'DETAILED_COLLECTION_NOT_FOUND': 'No se encontraron resultados en la colección detallada.',
      'DETAILED_COLLECTION_CREATE_REPORT': 'No se pudo generar el informe de la colección detallada.',
      //End DetailedCollection
  
      //Access
      'ACCESS_BY_COMPANY_NOT_FOUND': 'No se encontró acceso para la empresa seleccionada.',
      // EndAccess
  
      //Online-discounts
      'MODULE_ACCESS_NOT_FOUND': 'No se encontró acceso al módulo solicitado.',
      'DISCOUNTS_BY_LIQUIDATION_NOT_FOUND': 'No se encontraron descuentos asociados a la liquidación.',
      'ERROR_ACCESS_OWNER_REQUIRED': 'El propietario del acceso es obligatorio.',
      'ERROR_LIQUIDATION_TYPE_REQUIRED': 'El tipo de liquidación es obligatorio.',
      'ERROR_VOUCHER_REQUIRED': 'El comprobante es obligatorio.',
      'ERROR_RECORD_ID_REQUIRED': 'El ID del registro es obligatorio.',
      'ERROR_RECORD_TYPE_REQUIRED': 'El tipo de registro es obligatorio.',
      //EndOnline-discounts
  
      //Movements
      'LAST_MOVEMENTS_NOT_FOUND': 'No se encontraron los últimos movimientos.',
      'ERROR_PLATE_OR_CONSECUTIVE_REQUIRED': 'Debe proporcionar la placa o el consecutivo para realizar la búsqueda.',
      'ERROR_SEARCH_DATE_REQUIRED': 'La fecha de búsqueda es obligatoria.',
      'MOVEMENTS_BY_PLATE_OR_CONSECUTIVE_NOT_FOUND': 'No se encontraron movimientos asociados a la placa o consecutivo ingresado.',
      'MODULE_ACCESS_TOKEN_NOT_FOUND': 'El token de acceso al módulo no fue encontrado.',
      'ERROR_TITLE_MODULE_ACCESS_REQUIRED': 'El título de acceso al módulo es obligatorio.',
      'ERROR_SEARCH_ALL_MOVEMENTS': 'Ocurrió un error al consultar todos los movimientos.',
      'MOVEMENT_ERROR_PLATE_MIN_REQUIRED': 'Debe ingresar al menos un número de placa válido.',
      //EndMovements
  
      //CompanyForm
      'COMPANY_ERROR_SAVE': 'Ocurrió un error al guardar la información de la empresa.',
      'COMPANY_FORM_ERROR_QUERY_ID': 'No se pudo consultar la empresa por ID.',
      'COMPANY_FORM_ERROR_QUERY_ALL': 'No se pudo consultar la lista completa de empresas.',
      'COMPANY_FORM_ERROR_QUERY_CUSTOM': 'No se pudo realizar la consulta personalizada de empresas.',
      //EndCompanyForm
  
      //CompanySetting
      'COMPANY_SETTING_ERROR_SAVE': 'Ocurrió un error al guardar la configuración de la empresa.',
      'COMPANY_SETTING_ERROR_QUERY_FIND_TITLE_COMPANY': 'No se pudo encontrar la empresa por título.',
      'COMPANY_SETTING_ERROR_QUERY_FIND_COMPANY': 'No se pudo encontrar la empresa especificada.',
      'COMPANY_SETTING_ERROR_COMPANY_REQUIRED': 'La empresa es obligatoria para esta operación.',
      //EndCompanySetting
  
      //Tariff
      'TARIFF_ERROR_FIND_ID': 'No se encontró la tarifa con el ID proporcionado.',
      //EndTariff
  
      //InvoiceInfo
      'INVOICE_INFO_ERROR_FIND_ID_AND_TITLE': 'No se encontró la información de la factura por ID y título.',
      //EndInvoiceInfo
  
      //Invoice
      'INVOICE_ERROR_FIND_BY_PARAMETERS': 'No se encontraron facturas con los parámetros proporcionados.',
      'INVOICE_ERROR_PARAMETERS_NULL': 'Los parámetros de búsqueda de la factura no pueden estar vacíos.',
      'INVOICE_ERROR_SYNC': 'Ocurrió un error durante la sincronización de facturas.',
      'INVOICE_ERROR_SYNC_YESTERDAY': 'Error al sincronizar facturas del día anterior.',
      'INVOICE_ERROR_MISSING_DETAILS': 'Faltan detalles necesarios para la factura.',
      'INVOICE_ERROR_QUERY_FAILED': 'Error al realizar la consulta de facturas.',
      'INVOICE_ERROR_QUERY_BY_CODE_FAILED': 'No se pudo consultar la factura por código.',
      'INVOICE_ERROR_QUERY_INFORMATION': 'No se pudo consultar la información de la factura.',
      'INVOICE_ERROR_DELETE_FAILED': 'No se pudo eliminar la factura.',
      'INVOICE_ERROR_QUERY_TENANT_PAYMENT_FAILED': 'No se pudo consultar el pago del arrendatario.',
      'INVOICE_ERROR_QUERY_PAYMENT_INVOICE_FAILED': 'No se pudo consultar el pago asociado a la factura.',
      //EndInvoice
  
      //InvoiceDetail
      'INVOICE_DETAIL_ERROR_FIND_CODE': 'No se encontró el detalle de la factura por código.',
      //EndInvoiceDetail
  
      //MethodSetting
      'METHOD_SETTING_NOT_FOUND': 'No se encontró la configuración del método de pago.',
      'METHOD_SETTING_ERROR_SAVE': 'Ocurrió un error al guardar la configuración del método de pago.',
      'METHOD_SETTING_ERROR_QUERY_PAYMENT_GATEWAY': 'No se pudo consultar la pasarela de pago configurada.',
      //EndMethodSetting
  
      //Gopass
      'GOPASS_ERROR_NOT_FOUND_TERMINAL': 'No se encontró la terminal asociada a GoPass.',
      'GOPASS_ERROR_LIQUIDATION': 'Ocurrió un error con la liquidación de GoPass.',
      'GOPASS_ERROR_DENIED': 'El acceso a GoPass fue denegado.',
      //EndGopass
  
      //IncomeServiceConfig
      'INCOME_SERVICE_CONFIG_ERROR_SAVE': 'No se pudo guardar la configuración del servicio de ingreso.',
      'INCOME_SERVICE_CONFIG_ERROR_FIND_LIST': 'No se pudo obtener la lista de configuraciones del servicio de ingreso.',
      //EndIncomeServiceConfig
  
      //Income item
      'ERROR_INCOME_ITEM_LIST_BY_PLATE': 'No se pudo obtener la lista de ingresos por placa.',
      'ERROR_INCOME_SERVICE_CONFIG_FIND_BY_INCOME_SERVICE': 'No se encontró la configuración del servicio de ingreso asociada.',
  
      //VoucherDetail
      'VOUCHER_DETAIL_ERROR_FIND_UUID_CLASSIFICATION': 'No se pudo encontrar la clasificación del comprobante por UUID.',
      //EndVoucherDetail
  
      //PaymentMethods
      'METHOD_PROPERTY_ERROR_ID_REQUIRED': 'El ID del método de pago es obligatorio.',
      'ERROR_METHOD_REQUIRED': 'El método de pago es obligatorio.',
      'ERROR_SAVE_METHOD_SETTING': 'No se pudo guardar la configuración del método de pago.',
      'ERROR_FIND_METHOD_SETTING': 'No se pudo encontrar la configuración del método de pago.',
      'METHOD_PROPERTY_ERROR_FIND_BY_METHOD_SETTING': 'No se pudo encontrar la propiedad del método de pago desde su configuración.',
      'METHOD_SETTING_DETAIL_ERROR_LIST_BY_METHOD_SETTING': 'No se pudo listar los detalles de configuración por método de pago.',
      'METHOD_SETTING_DETAIL_ERROR_DELETE': 'No se pudo eliminar el detalle de la configuración del método de pago.',
      'METHOD_SETTING_DETAIL_ERROR_FIND_BY_METHOD_SETTING': 'No se pudo encontrar el detalle de configuración desde el método de pago.',
      //EndPaymentMethods
  
      //DynamicField
      'DYNAMIC_SELECT_ERROR_QUERY_CUSTOM': 'Error al ejecutar la consulta personalizada del campo dinámico.',
      'ELECTRONIC_ERROR_VALIDATE_CUFE': 'Error al validar el CUFE del documento electrónico.',
      //EndDynamicField
  
      //Accounting integration
      'ACCOUNTING_INTEGRATION_NOT_FOUND': 'No se encontró la integración contable solicitada.',
      //EndAccounting integration
      //SlotCount
      'LAST_SLOT_COUNT_NOT_FOUND': 'No se encontró el último conteo de cupos.',
      'SLOT_NOT_FOUND': 'No se encontró el cupo solicitado.',
  
      //Vehicle
      'VEHICLE_ERROR_FIND_IDENTIFICATION': 'No se pudo encontrar el vehículo por su identificación.',
      //End-Vehicle
      //VehicleTypes
      'VEHICLE_TYPES_PLATE_ERROR_QUERY': 'Error al consultar el tipo de vehículo por placa.',
      //endVehicleTypes
  
      //PlateRestriction
      'PLATE_RESTRICTION_ERROR_QUERY_LIST_BY_COMPANY': 'No se pudo consultar la lista de restricciones por empresa.',
      'PLATE_RESTRICTION_ERROR_QUERY_LIST_BY_PLATE_RESTRICTION': 'No se pudo consultar la lista de detalles por restricción de placa.',
      'PLATE_RESTRICTION_NOT_FOUND': 'No se encontró la restricción de placa solicitada.',
      'PLATE_RESTRICTION_DETAIL_ERROR_DELETE': 'No se pudo eliminar el detalle de la restricción de placa.',
      'PLATE_RESTRICTION_ERROR_SAVE': 'No se pudo guardar la restricción de placa.',
      'PLATE_RESTRICTION_DETAIL_ERROR_SAVE': 'No se pudo guardar el detalle de la restricción de placa.',
      'ERROR_PLATE_IS_REQUIRED': 'La placa es obligatoria.',
      'ERROR_PLATE_RESTRICTION_FIND_BY_ID': 'No se pudo encontrar la restricción de placa por ID.',
      'IS_HOLIDAY_OR_SPECIAL_DAY': 'Es un día festivo o un día especial.',
      'NOT_HAVE_RESTRICTION': 'La placa no tiene ninguna restricción.',
      'NOT_IN_SCHEDULE': 'La placa no está dentro del horario restringido.',
      'PLATE_NOT_FOUND': 'La placa no fue encontrada.',
      'PLATE_HAS_RESTRICTION': 'La placa tiene una restricción activa.',
      'ERROR_COMPANY_DOES_NOT_VALIDATE_PLATE_RESTRICTION': 'La empresa no valida las restricciones de placa.',
      //EndPlateRestriction
  
      //Calendar
      'ERROR_CALENDAR_FIND_BY_COMPANY_AND_DAY': 'No se pudo encontrar la configuración del calendario para la empresa y día indicados.',
      //End Calendar
      //Automation
      'ERROR_KACTUS_FILE_DOES_NOT_EXIST_OR_EMPTY': 'El archivo de Kactus no existe o está vacío.',
      'KACTUS_PROCESS_COMPLETED': 'El proceso de Kactus ha finalizado correctamente.',
      'CLOSURES_ATM_COMPLETED': 'Los cierres automáticos se han completado exitosamente.',
  
      //Discount
      'EMPTY_BARCODE': 'El código de barras está vacío.',
      'THE_INVOICE_HAS_ALREADY_BEEN_USED': 'La factura ya ha sido utilizada.',
      'INVALID_INVOICE_DATE': 'La fecha de la factura no es válida.',
      'QR_WITHOUT_IDENTIFICATION': 'El código QR no contiene una identificación.',
      'NO_MASKS_CONFIGURED': 'No se han configurado máscaras para el sistema.',
      'THE_QR_CODE_CANNOT_BE_PROCESSED': 'No se puede procesar el código QR.',
      'THE_INVOICE_DOES_NOT_CONTAIN_A_CUFE': 'La factura no contiene un CUFE.',
      'NOT_DISCOUNT_EXIST_FOR_INVOICE_RANGE': 'No existen descuentos para el rango de factura indicado.'
      //End-Discount
    }
}
